import { Routes } from '@angular/router';
import AdminRoutes from '@app/src/app/routes/admin/admin.routes';
import FrontRoutes from '@app/src/app/routes/public/front.routes';

export const routes: Routes = [AdminRoutes, FrontRoutes];
